<!-- =========================================================================================
    File Name: MailItem.vue
    Description: Mail Item - Displays mail item
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="notification-list__notification-item sm:px-4 px-2 py-6"
    :class="{ 'notification-list__opened-notification': notification.read_at }"
  >
    <!-- MAIL ROW 1 : META -->
    <div class="flex w-full">
      <div class="flex w-full justify-between items-start">
        <div class="mail__details">
          <h5 class="mb-1">{{ notification.title }}</h5>
        </div>

        <div class="notification-item__meta flex items-center">
          <div class="notification__labels hidden sm:flex items-center">
            <div
              class="h-2 w-2 rounded-full mr-2"
              :class="'bg-' + category[1].color"
            ></div>
          </div>
          <span>{{ elapsedTime(notification.created_at) }}</span>
        </div>
      </div>
    </div>
    <!-- /MAIL ROW 1 -->

    <!-- MAIL ROW 2 : MSG & ACTIONS -->
    <div class="flex w-full">
      <div class="truncate mr-24">
        <span style="white-space: pre;">{{ notification.content | truncate(100) }}</span>
      </div>
    </div>
    <!-- /MAIL ROW 2 -->
  </div>
</template>

<script>
import { DateUtil } from "@/utils";

export default {
  props: {
    notification: {
      type: Object,
      required: true
    },
    category: {
      type: Array,
      required: false
    },
  },
  data() {
    return {
      isSelectedMail: this.isSelected,
    };
  },
  computed: {
    labelColor() {
      return label => {
        const tags = this.tags;
        return tags.find(tag => {
          return tag.value == label;
        }).color;
      };
    }
  },
  methods: {
    elapsedTime(startTime) {
      return DateUtil.elapsedTime(startTime);
    }
  }
};
</script>
